import React from "react";
import Popup from 'reactjs-popup';
import Colors from "../utils/Colors";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Aux from "../utils/AuxFunctions";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import CheckFilledIcon from "mdi-react/CheckCircleIcon"
import CheckBlankIcon from "mdi-react/CircleOutlineIcon"
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import CloseIcon from "mdi-react/CloseCircleOutlineIcon";
import ImageEditIcon from "mdi-react/ImageEditIcon";
import ImagePlusIcon from "mdi-react/ImageAddIcon"
import Embed from "react-embed";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

class EditPostModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            post: {},
            error: "",
            loading: false,
            sucess: false,

            text: "",
            selectedPhoto: this.props.post.image ? this.props.post.image : null,
            uploadedPhoto: null,
            url: this.props.post.website ? this.props.post.website : null,
            hide: this.props.post.hide ? this.props.post.hide : false,

            updatedHide: false,
            updatedText: false,
            updatedUrl: false,
            updatedImage: false,

            deletePhoto: false,
            deleteUrl: false,
        }
    }

    componentDidMount() {
        try {
            this.setState({ selectedPhoto: this.props.post.image ? this.props.post.image : null, })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.post !== prevProps.post) {
            this.setState({
                post: this.props.post,
                selectedPhoto: this.props.post.image ? this.props.post.image : null,
                url: this.props.post.website ? this.props.post.website : null,
                hide: this.props.post.hide ? this.props.post.hide : false,
            })
        }
    }

    onEditPost = async (close) => {
        if (this.state.loading)
            return
        if (!this.state.text && !this.state.uploadedPhoto && !this.state.url && !this.state.updatedHide) {
            this.setState({ error: "Can't be empty" })
            return;
        }

        try {
            this.setState({ loading: true })
            Fire.shared.updatePost(
                this.props.post,
                this.state.text === this.state.post.text ? "" : this.state.text,
                this.state.uploadedPhoto,
                this.state.hide,
                this.state.url === this.state.post.url ? "" : this.state.url,
                this.state.deletePhoto,
                this.state.deleteUrl).then(isComplete => {
                    if (isComplete) {
                        this.setState({ loading: false, sucess: true })
                        close();
                    } else {
                        this.setState({ loading: false, error: "An unexpected error has occurred" })
                    }
                })
        } catch (error) {
            Aux.handleError(error)
            this.setState({ loading: false })
        }
    }

    deletePhoto = () => {
        this.setState({ selectedPhoto: null, uploadedPhoto: null, deletePhoto: true })
    }

    deleteUrl = () => {
        this.setState({ url: "", deleteUrl: true })
    }

    photoSelectedHandler = (event) => {
        let photo = URL.createObjectURL(event.target.files[0])
        this.setState({ selectedPhoto: photo, uploadedPhoto: event.target.files[0], url: "", deletePhoto: false, deleteUrl: true })
    }

    checkIfUrl = () => {
        if (this.state.selectedPhoto)
            return

        var urlRE = new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?([^ ])+");
        const output = this.state.text.match(urlRE)
        if (output?.length > 0) {
            this.setState({ url: output[0], selectedPhoto: null, uploadedPhoto: null, deletePhoto: true, deleteUrl: false })
        }

    }


    render() {
        return (
            <Popup
                contentStyle={{ width: "auto", borderRadius: 10, margin: "auto", overflowY: "auto", backgroundColor: "transparent", height: "100%" }}
                open={this.props.active}
                onClose={this.props.onClose}
                closeOnDocumentClick
                modal
            >
                {close => (
                    <div className="container login" style={{ display: "flex", flexDirection: "column", padding: 40, margin: "20px 0" }} >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <h2> Edit Post</h2>
                            <CloseIcon className={"button-hover"} size={30} onClick={close} ></CloseIcon>
                        </div>
                        <SucessMessage isSucess={this.state.sucess}></SucessMessage>
                        <div style={{ display: "flex", marginTop: 20, justifyContent: "space-around", flexDirection: "column", width: 350 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, backgroundColor: "#f7f7f7", borderRadius: 10, padding: 10 }}>
                                {this.state.hide ?
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        {Aux.showHidden(40)}
                                        <span style={{ marginLeft: 10 }}>Anonymous</span>
                                    </div> :
                                    <div style={{ display: "flex", alignItems: "center", overflow: "hidden" }}>
                                        {Aux.showAvatar(40, this.props.post.avatar, this.props.post.username || "Unknown")}
                                        <span style={{ marginLeft: 10, textOverflow: "ellipsis", overflow: "hidden" }}>{this.props.post.username || "Unknown"}</span>
                                    </div>
                                }

                                <div style={{ display: "flex", justifyContent: "center", color: this.state.hide ? Colors.mainColor : "grey", cursor: "pointer" }} onClick={() => this.setState({ hide: !this.state.hide, updatedHide: true })} className="button-hover">
                                    <span style={{ marginRight: 5 }}>Hide</span>
                                    {this.state.hide ? <CheckFilledIcon /> : <CheckBlankIcon />}
                                </div>
                            </div>
                            <div style={{ marginTop: 20 }}>
                                <ErrorMessage text={this.state.error}></ErrorMessage>
                                <TextInputMaterial onBlur={this.checkIfUrl}
                                    type="text" rows="4" placeholder="What's on your mind?" multiline={true}
                                    style={{ marginBottom: 10 }} value={this.props.post.text}
                                    styleInput={{ resize: "none", height: "100%", padding: 10, }}
                                    onChange={(e) => {
                                        this.setState({ text: e.target.value, updatedText: true });
                                    }} />
                                {this.state.url ?
                                    <div>
                                        <Embed key={this.state.url} url={this.state.url}></Embed>
                                        <div style={{ /* backgroundColor: Colors.red, */ display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: 5 /* padding: "7px 10px", borderRadius: 5, color: "white", cursor: "pointer" */ }}
                                            onClick={this.deleteUrl} >
                                            {/* <DeleteIcon></DeleteIcon> */}
                                            <span className="text-hover" style={{ color: Colors.red, cursor: "pointer" }}>Delete preview</span>
                                        </div>
                                    </div> : null}
                                {this.state.selectedPhoto ?
                                    <div>
                                        <img style={{ width: "100%", borderRadius: 5, objectFit: "cover", }}
                                            src={this.state.selectedPhoto ? this.state.selectedPhoto : Aux.TemporaryImage} alt="avatar">
                                        </img>
                                        <div style={{ /* backgroundColor: Colors.red, */ display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: 5 /* padding: "7px 10px", borderRadius: 5, color: "white", cursor: "pointer" */ }}
                                            onClick={this.deletePhoto} >
                                            {/* <DeleteIcon></DeleteIcon> */}
                                            <span className="text-hover" style={{ color: Colors.red, cursor: "pointer" }}>Delete Photo</span>
                                        </div>
                                    </div> : null}
                                <div style={{ display: "flex", }}>
                                    <label htmlFor="file" className="custom-file-upload">
                                        <div className="next-button button-hover" style={{ backgroundColor: "transparent", color: Colors.mainColor, borderRadius: 5, display: "flex", alignItems: "center", height: 30, borderWidth: 2, borderColor: Colors.mainColor, borderStyle: "solid" }}>
                                            {this.state.selectedPhoto ? <ImageEditIcon size={30} /> : <ImagePlusIcon size={30} />}
                                            <span style={{ marginLeft: 10, color: Colors.mainColor, fontSize: 10, fontWeight: "bold" }}>{this.state.selectedPhoto ? "Change photo" : "Add photo"}</span>
                                        </div>
                                    </label>
                                    <input id="file" type="file" className="file-upload" onChange={this.photoSelectedHandler} />
                                </div>
                            </div>
                            <div style={{ borderWidth: 1, borderColor: "#eee", borderStyle: "solid", margin: "15px 0" }} />
                            <ButtonLoader
                                text="Edit Post"
                                style={{ backgroundColor: Colors.mainColor, marginTop: 20 }}
                                onClick={() => this.onEditPost(close)}
                                loading={this.state.loading}
                            />
                        </div>
                    </div>)}
            </Popup>
        );
    }
}

export default withMyDataContext(EditPostModal)